import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoansByFundraisingId = id => {
  return useQuery({
    staleTime: 1000 * 60 * 60,
    queryKey: [QUERY_KEYS.loan.loans_by_fundraising_id, id],
    queryFn: () =>
      loanService.loanByFundraisingId(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
